import React, { useState } from 'react'
import backgroundImage from "assets/images/seats1.jpg";
import EventsOnDate from 'components/EventBooking/eventsOnDate'
import TailwindLayout from 'TailwindcssComponents/TailwindLayout'
import TopBar from 'TailwindcssComponents/TopBar'
import FooterTailwind from 'TailwindcssComponents/Footer'

export default function EventBookings() {

    return (
        <TailwindLayout>
            <TopBar />
            <div className="relative p-12">
                {/* Hero section with background image */}
                <div
                    className="relative flex items-center min-h-[18.75rem] rounded-xl overflow-hidden"
                    style={{
                        backgroundImage: `linear-gradient(to right, rgba(58, 65, 111, 0.6), rgba(58, 65, 111, 0.6)), url(${backgroundImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '50%'
                    }}
                />

                {/* Card overlay */}
                <div className="relative -mt-12 mx-3 py-4 px-4 bg-white rounded-xl shadow-lg">
                    <div className="grid gap-12 items-center">
                        <div className="mt-2">
                            <h5 className="text-xl font-medium mb-2">
                                Your Gateway to Exciting Events...
                            </h5>
                            <p className="text-gray-700 text-sm font-normal">
                                Explore our curated selection of upcoming events and secure your spot today.
                            </p>
                        </div>
                    </div>
                </div>

                {/* Events section */}
                <div className="mt-20 mb-12">
                    <EventsOnDate />
                </div>
            </div>
            <FooterTailwind />
        </TailwindLayout>
    )
}